module.exports = (__webpack_require__(8))(24);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/models/AccessControlledModel.js from dll-reference girder_lib
// module id = 964
// module chunks = 0